<ng-container *ngIf="song">
  <app-card [title]="'feature.song.song_info' | translate" [type]="3">
    <app-song-menu-btn card3BtnLeft1 [song]="song"></app-song-menu-btn>
    <app-song-like-btn card3BtnLeft2 [song]="song"></app-song-like-btn>
    <div cardBody3 class="row">
      <div class="col-md-6">
        <h6 class="d-inline">{{ 'common.label.title' | translate }}:&nbsp;</h6>
        <span>{{song.title}}</span>
        <br />
        <h6 class="d-inline">{{ 'feature.song.release_date' | translate }}:&nbsp;</h6>
        <span>{{ song.releaseDate | date: 'dd/MM/yyyy' : '' : translate.currentLang }}</span><br />
        <h6 class="d-inline">{{ 'common.entity.artist' | translate }}:</h6>
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let artist of artistPage.content; index as i">
            <img
              class="mx-1"
              [routerLink]="['/artist/detail']"
              [queryParams]="{id: artist.id}"
              [src]="artist.avatarUrl | mediaUrl"
              alt=""
            />
            <a [routerLink]="['/artist/detail']" [queryParams]="{id: artist.id}">{{artist.name}}</a>
          </li>
        </ul>
        <ngb-pagination
          *ngIf="artistPage.totalPages > 1"
          [collectionSize]="artistPage.totalElements"
          [page]="artistPage.pageable?.pageNumber + 1"
          [pageSize]="artistPage.pageable?.pageSize"
          (pageChange)="getArtistList($event - 1)"
        ></ngb-pagination>
        <h6 class="d-inline">{{ 'common.entity.country' | translate }}:&nbsp;</h6>
        <span>{{song.country?.name}}</span>
        <br />
        <h6 class="d-inline">{{ 'common.entity.genre' | translate }}:&nbsp;</h6>
        <span>{{song.genres | stringArray}}</span>
        <br />
        <h6 class="d-inline">{{ 'common.entity.tag' | translate }}:&nbsp;</h6>
        <span>{{song.tags | stringArray}}</span>
        <br />
        <h6 class="d-inline">{{ 'common.entity.theme' | translate }}:&nbsp;</h6>
        <span>{{song.theme?.name}}</span>
        <br />
      </div>
      <div class="col-md-6">
        <h6 class="d-inline">{{ 'feature.song.lyric' | translate }}:&nbsp;</h6>
        <p style="height: 12rem; overflow-y: auto; word-break: break-word; white-space: pre-line">{{song.lyric}}</p>
      </div>
    </div>
  </app-card>
  <h4 class="my-4">{{ 'common.entity.comment' | translate }}</h4>
  <app-comment-box *ngIf="songId" [type]="'SONG'" [id]="songId"></app-comment-box>
</ng-container>
